module.exports = function (fox) {
    'use strict';
    fox.registerWidget('Page_CCPA', {
        configure() {
            this.registerOptions('', {
                template: 'page_ccpa',
                autoRender: true,
                handleDom: {
                    showPopup: {
                        event: 'click',
                        target: '[show-popup]',
                        callback: 'showPopup'
                    },
                }
            });

            this.callParent('configure', arguments);
        },

        showPopup() {
            // 
        }
    });
};



// WEBPACK FOOTER //
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common-components/CCPA/widget/page.es.js